import React from 'react';

class LoginFooter extends React.Component {
    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div className="row footer_div">
            <div className="col-md-1"></div>
                <div className="col-md-3 service">
                    <p className="footer_font">FIND SERVICES</p>
                    <p className="footer_font">> Category List</p>
                    <p className="footer_font">> Request Board</p>
                    <p className="footer_font">> User Guide</p>
                    <img src="facebook.png" className="" alt="" />
                </div>

                <div className="col-md-4 service">
                    <p className="footer_font">SELL SERVICES</p>
                    <p className="footer_font">> Sell</p>
                    <p className="footer_font">> Tips for listing</p>
                    <p className="footer_font">> Service price, paid options</p>
                    <p className="footer_font">> Seller vinterview</p>
                </div>

                <div className="col-md-4 service">
                    <p className="footer_font">LEARN MORE</p>
                    <p className="footer_font">> Home</p>
                    <p className="footer_font">> About Us</p>
                    <p className="footer_font">> FAQs</p>
                </div>
            </div>
        );
    }
}

export { LoginFooter };